import React, { createContext, useContext, ReactNode } from "react";
import { useOrderUploader } from "../hooks/useOrderUploader";
import { FetchedOrderUploadProduct, IProgressBarLevel } from "../types";
import { AlertContent } from "../../../interfaces/interfaces";
import { OrderUploadResult } from "../ModalSwitcher";

interface OrderUploaderContextType {
  // State
  fetchedProducts: FetchedOrderUploadProduct[];
  toast: AlertContent | null;
  isLoading: boolean;
  modalToShow: OrderUploadResult | null;
  progressBarLevel: IProgressBarLevel;

  // Actions
  handleFileUpload: (csvEachLineArray: string[][]) => Promise<void>;
  handleRemoveItem: (sku: string) => void;
  handleReloadItem: (sku: string) => void;
  handleClearCart: () => Promise<void>;
  setToast: React.Dispatch<React.SetStateAction<AlertContent | null>>;
  setModalToShow: React.Dispatch<React.SetStateAction<OrderUploadResult | null>>;
  setFetchedProducts: React.Dispatch<React.SetStateAction<FetchedOrderUploadProduct[]>>;
}

const OrderUploaderContext = createContext<OrderUploaderContextType | undefined>(undefined);

interface OrderUploaderProviderProps {
  children: ReactNode;
}

export const OrderUploaderProvider: React.FC<OrderUploaderProviderProps> = ({ children }) => {
  const orderUploaderState = useOrderUploader();

  return (
    <OrderUploaderContext.Provider value={orderUploaderState}>
      {children}
    </OrderUploaderContext.Provider>
  );
};

export const useOrderUploaderContext = (): OrderUploaderContextType => {
  const context = useContext(OrderUploaderContext);
  if (context === undefined) {
    throw new Error("useOrderUploaderContext must be used within an OrderUploaderProvider");
  }
  return context;
};
